import styled from 'styled-components';
import { responsiveText } from 'utilities/style';
import ContentTypography from 'components/ContentTypography';

const BlockContentTypography = styled(ContentTypography)`
  ${responsiveText(16, 18, 0.9)};
`;

export default BlockContentTypography;
